/** @jsx jsx */
import { jsx, Flex, Box, Styled } from "theme-ui"
import ProductCard from "./productCard"

export default props => (
  <Flex sx={{ flexWrap: "wrap", justifyContent: "center", my: 4, mx: -3 }}>
    {props.children}
  </Flex>
)
